<template>
<div>

	<!-- page-heading -->
	<page-heading show="true" :showBack="true" pageTitle="HEADER-VOUCHERS"></page-heading>

	<loading-indicator :loading="isLoading"></loading-indicator>

	<template v-if="!isLoading">

        <div class="columns">

            <div class="col-main">

				<div class="box">

                <!-- 3 GS -->
                <template v-if="data.voucherPackage == 11">

					<div class="columns is-marginless">

						<!-- IMAGE PREVIEW -->
						<div class="column is-4">

							<div class="control">

								<div class="control-label">
									<label-name labelKey="APO_VIEW-LABEL_PREVIEW-VOUCHER"></label-name>
								</div>

								<div class="control">

									<img class="lazy-img-fadein preview" v-lazy="getAsset('front')" />

									<template v-if="isSupplement && data.voucherBackPreview && data.voucherBackPreview.path != null">
										<img class="lazy-img-fadein preview" v-lazy="getAsset('back')" />
									</template>

								</div>
							</div>

						</div>

						<div class="column is-8">

							<div class="inner">

								<template v-for="index in 3">

									<div class="control">
										<div class="control-label">
											<label-name :labelKey="'SITE_CATALOG_VOUCHER_TEXT_'+index"></label-name>
										</div>
										<div class="control">
											<textarea :id="'SITE_CATALOG_VOUCHER_TEXT_'+index" class="textarea is-medium" type="text" v-model="data['voucherText'+index]" :disabled="isDisabled"></textarea>
										</div>
									</div>

								</template>

							</div>

						</div>


                    </div>

                </template>


                <!-- 6 GS -->
                <template v-else-if="data.voucherPackage == 12">

					<div class="columns is-marginless">

						<!-- IMAGE PREVIEW -->
						<div class="column is-4">

							<div class="control">
								<div class="control-label">
									<label-name labelKey="APO_VIEW-LABEL_PREVIEW-VOUCHER"></label-name>
								</div>
								<div class="control">

									<img class="lazy-img-fadein preview" v-lazy="getAsset()" />

									<template v-if="isSupplement && data.voucherBackPreview && data.voucherBackPreview.path != null">
										<img class="lazy-img-fadein preview" v-lazy="getAsset('back')" />
									</template>

								</div>
							</div>

						</div>

						<div class="column is-8">

							<div class="inner">


								<template v-for="index in 6">

									<div class="control">
										<div class="control-label">
											<label-name :labelKey="'SITE_CATALOG_VOUCHER_TEXT_'+index"></label-name>
										</div>
										<div class="control">
											<textarea :id="'SITE_CATALOG_VOUCHER_TEXT_'+index" class="textarea is-medium" type="text" v-model="data['voucherText'+index]" :disabled="isDisabled"></textarea>
										</div>
									</div>

								</template>


							</div>

						</div>


                    </div>

                </template>

                <template v-else>

                    keine Gutscheine

                </template>



				</div>

				<!-- COMMENTS -->
				<comments :threadID.sync="data.voucherThread" threadFieldName="voucherThread" :api="'siteCatalog/'+data.id"></comments>

            </div>

            <div class="col-aside">

				<affix :offset="50">

	                <div class="sidebox">
	                    <custom-button type="blue" icon="icon-ak-speichern" :disabled="isDisabled" name="SITE_BUTTON_SAVE" :loading="isSaving" @click.native="formSubmit"></custom-button>
	                </div>

					<div class="sidebox">

						<template v-if="!isSupplement">

							<a :href="downloadURL" :download="extRef+'-gutscheine.pdf'" v-if="getAsset()">
								<custom-button type="dark" icon="icon-ak-download" name="PDF"></custom-button>
							</a>
						</template>

						<template v-else>

							<template v-if="isSupplement && data.voucherPreview && data.voucherPreview.path != null">

								<a :href="downloadURL" :download="extRef+'-gutscheine-1.pdf'">
									<custom-button type="dark" icon="icon-ak-download" name="PDF"></custom-button>
								</a>

							</template>

							<template v-if="isSupplement && data.voucherBackPreview && data.voucherBackPreview.path != null">
								<a :href="downloadURL('back')" :download="extRef+'-gutscheine-2.pdf'">
									<custom-button type="dark" icon="icon-ak-download" name="PDF (Rückansicht)"></custom-button>
								</a>
							</template>

						</template>

					</div>


				</affix>

            </div>

        </div>

    </template>

</div>

</template>



<script>
import comments from '../../utils/incl-comments';

export default {

	components: {
		comments
    },

    data() {

		return {
            data: [],
			extRef: null,
            isSaving: false,
            isLoading: false
		}
	},

    created() {

		this.fetchData();

    },

    mounted() {

    },

	computed: {

		isSupplement() {
			return this.$store.getters.getCurrentCatalog.hasCustomizationModeSupplement;
		},

		isDisabled() {
			return ['NONE', 'APPROVAL_REQUESTED', 'PRINT_APPROVAL_REQUESTED', ].indexOf(this.data.status.name) == -1;
		},

		// getAsset() {
        //     return this.$config.assets + this.data.voucherPreview.path + '/' + this.data.voucherPreview.filename;
        // },

		voucherStatus() {
			return this.$store.getters.getTermsByTaxonomy('VOUCHER_STATUS');
		},

	},


    methods: {

		downloadURL(type='front') {

			if(type != 'back') {
				var asset = this.$config.assets + this.data.voucherPreview.path + '/' + this.data.voucherPreview.filename;
			} else {
				var asset = this.$config.assets + this.data.voucherBackPreview.path + '/' + this.data.voucherBackPreview.filename;
			}

			return asset.substr(0, asset.lastIndexOf(".")) + ".pdf";

		},

		getAsset(type='front') {

			if(type=='front') {
				return this.$config.assets + this.data.voucherPreview.path + '/' + this.data.voucherPreview.filename;
			} else {
				return this.$config.assets + this.data.voucherBackPreview.path + '/' + this.data.voucherBackPreview.filename;
			}
        },

		fetchData() {

            this.isLoading = true;


			let url = this.$config.api + 'site/'+this.$store.getters.getUser.site.id+'?include=siteCatalog.status,site.siteCatalogs,siteCatalog.package,siteCatalog.voucherPreview,siteCatalog.voucherBackPreview&filters[siteCatalogs.catalog]='+this.catalogId;

	            this.axios.get(url)
	                .then(res => {

						this.extRef = res.data.extRef;

                        this.data = res.data.siteCatalogs[0];
	                    this.isLoading = false;

	                })
	                .catch(err => {

	                    this.isLoading = false;
	                    console.log(err);

	                });

		},

        formSubmit() {

            this.entityCreateOrUpdate('siteCatalog', this.data);

        }


    }

}


</script>

<style scoped>

	.col-main {
	    padding: 25px;
	}

	img.preview {
		display: block;
		width: 100%;
		height: auto;
		max-height: 50vh;
		object-fit: contain;
	}

	.groupTitle {
		margin: 0 0 25px 0;
	}

	.control-label {
		padding: 0 0 5px 0;
		margin: 0;
	}
	.control-label label {
		padding: 0;
	}

	.previewTitle {
		position: absolute;
		top: -20px;
		width: 100%;
		height: 25px;
		font-weight: normal;
	    text-transform: uppercase;
	    font-size: 12px;
	    font-weight: 400;
	    cursor: pointer;
	}

</style>
